// extracted by mini-css-extract-plugin
module.exports = {"footerDiv":"Quizzes_footerDiv__1GlWM","PageNumberDiv":"Quizzes_PageNumberDiv__MeiH3","ArrowButton":"Quizzes_ArrowButton__nYS-c","InputPage":"Quizzes_InputPage__2qPU-"};